















import Vue, { PropType } from 'vue';
import SectionForm, {
  FormDataInterface,
} from '@/containers/cv-section-date/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionDateStoreEdit from '@/store/modules/cvSectionDateEdit';
import { CvSectionDate } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionForm,
  },
  props: {
    section: {
      type: Object as PropType<CvSectionDate>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title }: FormDataInterface) {
      const { cv_id, id } = this.section;
      await this.$store.dispatch(
        CvSectionDateStoreEdit.UpdateCvSectionDate.namespaced({
          params: {
            cv_id,
            id,
          },
          body: {
            title,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
      // refresh sections
      this.$store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id }));
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
    async onDelete() {
      const { cv_id, id } = this.section;
      await this.$store.dispatch(
        CvSectionDateStoreEdit.DeleteCvSectionDate.namespaced({
          params: {
            cv_id,
            id,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      // refresh sections
      this.$store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id }));
      this.$router.push({ name: 'cv_edit_path' });
    },
  },
});
